export default function exerciseIconUrl(icon: string): string {
    const cdnBaseUrl = import.meta.env.DEV
        ? "https://asset.strawberry.me"
        : import.meta.env.VITE_CDN_URL;
    return `${cdnBaseUrl}/${icon}`;
}
